<template>
	<div class="container-fluid" id="dvcrud">
		<div class="row">
			<div class="col-md-12">
					<breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
			</div>
			<div class="col-md-12">
				<div id="pnlista" class="card" style="display: none;">
					<div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
						<router-link to="/">
								<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</router-link>
					</div>
					<div class="card-body" style="padding: 10px;">
						<div class="row">
							<div class="col-sm-12 col-md-10 col-lg-10">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilial">
                                </select>
                            </div>

							<div class="col-12 col-sm-6 col-md-2 col-lg-2">
								<button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
							</div>
							<div class="col-12" style="margin-top: 10px;">
								<!-- corpo -->
                                <div class="row">
                                  
                                    <div v-for="(mesa) in lstmesascomandas" :key="mesa.id" style="padding-bottom: 15px;" @click.prevent="mtdgerenciarmesa(mesa)" class="col-lg-1 col-md-2 col-sm-4 col-4">
                                        <div v-if="parseInt(mesa.ocupado)===0"  class="card" style="background-color: #48ff72; height: 70px !important;">
                                            <div class="card-body">
                                                <span style="position: relative; top: -21px; left: -15px;">{{ mesa.id }}</span>
                                            </div>
                                        </div>

                                        <div v-else class="card" :style=" parseInt(mesa.unida)===0 ? 'background-color: #ff4343; height: 70px !important;' : 'background-color: #ff7f00; height: 70px !important;'">
                                            <div class="card-body">
                                                <span style="position: relative; top: -21px; left: -15px; color: white;"> {{ mesa.id }} </span>
                                                <span style="position: relative; color: white; top: -19px; right: -22px;" > <i class="fa fa-user" aria-hidden="true"></i> </span>
                                                <span style="position: relative; top: -17px; left: 21px; color: white; font-size: 11px;"> {{ mesa.qtdpessoas }} </span>
                                                
                                                <div class="text-center">
                                                    <span style="font-size: 10px; padding-bottom: 0; color: white; width: 100%;"> {{  mtdformatavalordecimal(parseFloat(mesa.totmesa) + parseFloat(mesa.tottaxa), 2)}} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

							</div>
							<div class="col-md-12">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										Registros
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstmesascomandas.length}}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="pncadastro" class="card" style="display:none;">
			<div class="card-header"><span>{{itensbc.item2.titulo}}</span>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
			</div>
			<div class="card-body">
				<div class="row">   
					<div class="col-md-12">
						<div class="alert alert-secondary" style="background-color: #ffffff; padding: 10px;" role="alert">
							<div class="row">
								<div class="col-sm-12 col-md-2 col-lg-2">
									<label for="edidproperda">Comanda / mesa:</label>
									<input type="text" class="form-control form-control-sm" id="edidproperda" v-model="vidcomandaedicao"
										maxlength="20" :disabled="parseInt(vestadoedicao) === 1"/>
								</div>
								<div class="col-sm-12 col-md-8 col-lg-8">
									<label for="eddescricaoproperda">Quantidade de pessoas:</label>
									<input type="number" v-model="vqtdpessoasedicao" class="form-control form-control-sm" id="eddescricaoproperda" maxlength="50">
								</div>
								<div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 20px;">
									<div v-if="parseInt(vestadoedicao) === 1" class="dropdown">
										<button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
											<i class="fa fa-navicon"></i> Opções em uso
										</button>
										<div class="dropdown-menu">
											<a class="dropdown-item" href="#" @click.prevent="mtdmigrarcomanda()"><i class="fa fa-exchange"></i> Migrar comanda</a>
											<a class="dropdown-item" href="#" @click.prevent="mtdunircomanda()"><i class="fa fa-sitemap"></i> Unir comanda</a>  
											<a class="dropdown-item" href="#" @click.prevent="mtdliberarcomanda()"><i class="fa fa-ban"></i> Liberar comanda</a>                                                                                                                   
											<a class="dropdown-item" href="#" @click.prevent="mtdimprimircomanda()"><i class="fa fa-wpforms"></i> Imprimir comanda</a>                                                                                                                   
										</div>
									</div>
									<span v-else class="btn btn-block btn-primary" style="background: #5a956a; float: right;  font-size: 12px;">Livre</span>                                        
								</div>                                                                                                
							</div>
						</div>                                                                
					</div>  
					<div class="col-md-12">
						<div class="tab-content border-left border-right border-bottom" style="margin-bottom: 15px;">
							<div class="row">
								<div class="col-12">
									<div class="table-responsive">
										<table class="table table-bordered table-sm table-hover">
											<thead class="thead-light">
												<tr>
													<th>Opção</th>
													<th>Item</th>
													<th>Idproduto</th>
													<th>Descrição</th>
													<th>Valor</th>
													<th>Quantidade</th>
													<th>Desconto</th>
													<th>Total</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in lstitens" v-bind:key="index">
													<td style="width: 90px;">			
														<a class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
															v-bind:disabled="ativadesativa"
															@click.prevent="mtdeditaritem(item, index)" title="Alterar">
															<i class="fa fa-edit"></i>
														</a>                                                                         
														<a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
															v-bind:disabled="ativadesativa"
															@click.prevent="mtdexcluiritem(item, index)" title="Excluir">
															<i class="fa fa-trash"></i>
														</a>
												    </td>
													<td style="font-weight: 600; width: 50px;">{{ item.item }}</td>
													<td style="font-weight: 600;">{{ item.idproduto }}</td>
													<td>{{ item.descricao }}</td>
													<td style="text-align: right;">
														{{mtdformatavalordecimal(parseFloat(item.valor), 2)}}
													</td>                                        
													<td style="text-align: right; font-weight: 600;">
														{{parseFloat(item.qtditem)}}
													</td>
													<td style="text-align: right; font-weight: 600;">
														<span class="text-secondary">{{mtdformatavalordecimal(parseFloat(item.desconto), 2)}}</span>
													</td>
													<td style="text-align: right; font-weight: 600;">
														<span class="text-success">{{mtdformatavalordecimal(parseFloat(item.total), 2)}}</span>
													</td>                                        
												</tr>
											</tbody>
										</table>
									</div>      
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="alert alert-secondary" style="background-color: #ffffff; padding: 10px;" role="alert">
										<div class="row">
											<div class="col-sm-10 col-md-10 col-lg-10">
											</div>
										
											<div class="col-sm-2 col-md-2 col-lg-2" style="padding-top: 15px;">
												<span class="btn btn-block btn-primary" @click.prevent="mtdlanciten()" style="background: #4a976a; float: right;  font-size: 12px;">Adicionar itens</span>                                        
											
											</div>                                                                                                
										</div>
									</div>                                                                
								</div>  
							</div>
						</div>                  
					</div>
					<div class="col-md-12">
						<ul class="list-group">
							<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
								<span style="font-weight: 600;">Produtos</span>
								<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(vtotalproduto), 2)}}</span>
							</li>
							<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
								<span style="font-weight: 600;">Tx serviço</span>
								<span class="badge badge-secondary badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(vtxservico), 2)}}</span>
							</li>
							<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
								<span style="font-weight: 600;">Total</span>
								<span class="badge badge-primary badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(vtotalproduto) + parseFloat(vtxservico), 2)}}</span>
							</li>
						</ul>      
					</div>              
				</div>
			</div>
			<div class="card-footer">
				<div class="row">
					<div class="col-sm-8">
						<h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
					</div>
					<div class="col-sm-2">
						<button id="btgravar" type="button" @click.prevent="mtdgravar()"
								class="btn btn-primary btn-sm"
								style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
						</button>
					</div>
					<div class="col-sm-2">
						<button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
							<i class="fa fa-close"></i> Cancelar
						</button>
					</div>
				</div>
			</div>
		</div>
	    <!-- Modal de edição do ítem do pedido -->
		<div class="modal fade" id="mdedicaoitem">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 v-if="parseInt(vopitem) === 1" class="modal-title"><i class="fa fa-edit"></i> Edição do ítem</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edidprodutoedicao">Produto:</label>
								<input type="text" class="form-control form-control-sm" id="edidprodutoedicao" disabled v-model="vcoddigedicao" maxlength="20" style="text-transform: uppercase;">
							</div>
							<div class="col-sm-12 col-md-7 col-lg-7">
								<label for="eddescricaoprodutoedicao">Descrição do produto:</label>
								<input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold;" disabled>								
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edqtditemedicao">*Quantidade:</label>
								<div class="input-group" style="z-index: 1;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdquantidade(2)"><i class="fa fa-minus"></i></a>
									</div>									
									<money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdquantidade(1)"><i class="fa fa-plus"></i></a>
									</div>									
								</div>
							</div>								
							<div class="col-sm-12 col-md-3 col-lg-3">
								<label for="cbtipodescacresedicao">Desconto:</label>
								<select class="form-control form-control-sm" id="cbtipodescacresedicao" v-model="vtipodescacresedicao" v-bind="calculatotalitem" >
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edvaldescacresedicao">Desconto </label>
								<money type="text" class="form-control form-control-sm" id="edvaldescacresedicao" v-model="vvalordescacresedicao" v-bind="[calculatotalitem, money]"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edvlunitarioedicao">*Valor Unitário:</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vvlunitarioedicao"  v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edvltotaledicao">Total:</label>
								<money type="text" class="form-control form-control-sm" id="edvltotaledicao" v-model="vvltotaledicao" v-bind="[calculatotalitem, money]" readonly style="font-weight: bold; text-align:right;"></money>
							</div>																																															
						</div>
											
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" id="btnsalvaritem" @click.prevent="mtdgravaritem()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
	    <!-- Modal de edição do ítem do pedido -->
		<div class="modal fade" id="mdlanciten">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Lançar itens rápidos</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row" style="padding-bottom: 30px; !important">
							<div class="col-12">
								<div id="slickbtns">
									<div v-for="(item, index) in lstbotoes" :key="index" class="row" @click.prevent="mtdselecionabotao(index)">
										<div class="col-12">
											<div v-if="parseInt(item.ativo)===0" class="card cardbtn">
												<!-- <div class="card-body">
													<div class="text-center">
														<span class="responsive">{{ item.descricao }}</span>
													</div>
												</div> -->
												<div class="card-body d-flex align-items-center justify-content-center">
													<div class="row">
														<div class="container">
															<div class="d-flex">
																<!-- Conteúdo do card aqui -->
																<span class="responsive">{{ item.descricao }}</span>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div v-else class="card cardbtn-ativo">
												<!-- <div class="card-body">
													<div class="text-center">
														<span class="responsive">{{ item.descricao }}</span>
													</div>
												</div> -->
												<div class="card-body d-flex align-items-center justify-content-center">
													<div class="row">
														<div class="container">
															<div class="d-flex">
																<!-- Conteúdo do card aqui -->
																<span class="responsive">{{ item.descricao }}</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<ul class="list-group">                                           
									<li v-for="(item, index) in lstitensbotoes" :key="index"  class="list-group-item list-group-item-action" style="padding: 5px 15px 5px 15px;">
										<div class="row">
											<div class="col-10">
												<div class="row">
													<div class="col-2 col-md-2 col-lg-2 col-xl-2">
														{{ item.idproduto }}
													</div>   
													<div class="col-8 col-md-8 col-lg-4 col-xl-4">
														{{ item.descricao }}
													</div>  
													<div class="col-2 col-md-2 col-lg-2 col-xl-2">
														{{ item.valor }}
													</div> 
													<div class="col-8 col-md-8 col-lg-4 col-xl-4">
														<label for="qtditembtn">Quantidade:</label>
														<div class="input-group" style="z-index: 1;">
															<div class="input-group-append">
																<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdalterarqtd(false, 1, index)"><i class="fa fa-minus"></i></a>
															</div>									
															<money type="text" class="form-control form-control-sm" id="qtditembtn" disabled v-model="item.qtd" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
															<div class="input-group-append">
																<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdalterarqtd(true, 1, index)"><i class="fa fa-plus"></i></a>
															</div>									
														</div>
													</div>    
													<div class="col-2 col-md-2">
														{{ item.total }}
													</div>                                                                                                                                                                                                                                                                                                                 
												</div>
											</div>
											<div style="background-color: #0acf97 !important; border-radius: 15px" class="col-2" @click.prevent="mtdincluirproduto(index)">
												<div class="card-body d-flex align-items-center justify-content-center" style="margin-top: 8px">
													<div class="row">
														<div class="container">
															<div class="d-flex">
																<!-- Conteúdo do card aqui -->
																<span class="responsive" style="color: white;" ><i class="fa fa-plus" aria-hidden="true"></i></span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>	
									</li>
								</ul>												
							</div>
						</div>		
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>

		 <!-- Modal -->
		 <div class="modal fade" id="mdselecionarcomanda" role="dialog">
			<div class="modal-dialog modal-sm">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Selecionar comanda</h4>
					    <button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-12">
								<label for="edidproperda">Comanda / mesa:</label>
								<input type="text" class="form-control form-control-sm" id="edidproperda" v-model="vidcomandaedicao"
									disabled>
							</div>
							<div class="col-12">
								<label for="edidproperda">Novo numero:</label>
								<input type="text" class="form-control form-control-sm" id="edidproperda" v-model="vidnovacomanda"
								 >
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button v-if="opcomanda===1" type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmamigranovacomanda()"><i class="fa fa-close"></i> Confirmar</button>
						<button v-if="opcomanda===2" type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaunircomanda()"><i class="fa fa-close"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import BreadCrumb from '../components/cmpbreadcrumb.vue'
	import util from '../utilitarios/util.js'
	import 'slick-carousel/slick/slick.css';
    import 'slick-carousel/slick/slick-theme.css';
    import 'slick-carousel/slick/slick.js';

	export default {
		name: 'cadmesascomandas',
		components:{
			'breadcrumb' : BreadCrumb
		},
		data: function() {
			return {
                pidfilial               : null,
                utodasfiliais 		    : this.$store.state.usuario.todasfiliais,
                lstmesascomandas        : [],
				lstitensbotoes          : [],
				vtaxafil                : 0,
				vtptaxafil              : 0, 

				lstbotoes               : [],

				opcomanda               : 0,  

				//edição mesas comandas
				lstitens                : [], 
				vidcomandaedicao        : 0,
				vqtdpessoasedicao       : 1,
				vestadoedicao           : 0,
				vtotalcomanda           : 0,
				vtotalproduto           : 0,
				vitem                   : 0,
				vtxservico              : 0, 

				vcoddigedicao			: '',
				vdescricaoprodutoedicao	: '',
				vqtditemedicao			: 0,	
				vtipodescacresedicao	: 0,
				vvalordescacresedicao	: 0,
				vvlunitarioedicao		: 0,
				vvltotaledicao			: 0,

				//variaveis edicçao comanda
				vidnovacomanda         : 0,





				options: {
					format              : 'DD/MM/YYYY',
					useCurrent          : false,
					locale              : 'pt-BR'
				},
				money: {
					decimal             : ',',
					thousands           : '.',
					prefix              : '',
					precision           : 2,
					masked              : false
				},

				//variável para habilitação dos campos
				ativadesativa         : true,

				bootstrapPaginationClasses: {
					ul: 'pagination pagination-sm',
					li: 'page-item',
					liActive: 'active',
					liDisable: 'disabled',
					button: 'page-link'
				},
				itensbc : {
					item1 : {
						titulo : 'MESAS/COMANDAS',
						ativo  : false
					},
					item2 : {
						titulo : '',
						ativo  : false
					}
				},
				
			}
		},
		methods:{
			mtdconfirmaunircomanda(){
				let vself = this;
				if(parseInt(this.vidnovacomanda) === parseInt(this.vidcomandaedicao)){
					this.$toastr.w('as comandas/mesas não podem ser iguais', 'Atenção!');
					return
				}
				if((parseInt(this.vidnovacomanda) > this.lstmesascomandas.length)||(parseInt(this.vidnovacomanda) <= 0 )){
					this.$toastr.w('o número informado é inválido!', 'Atenção!');
					return
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma a união da comanda?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
					sim: {
						text: '<u>S</u>im',
						keys: ['s', 'S'],
						btnClass: 'btn-blue',
						action: function () {
							$('.btn-blue').prop('disabled', true);

							let loader = vself.$loading.show();
		
							let parametros      = [
								{parametro: 'idclientesac',  	  valor : vself.$store.state.filialpadrao.idcliente},
								{parametro: 'op',           	  valor : 'unircomanda'}, 
								{parametro: 'idcomanda',          valor : vself.vidcomandaedicao},
								{parametro: 'idnovacomanda',      valor : vself.vidnovacomanda},
								{parametro: 'idfilialcomanda',    valor : vself.pidfilial},
								{parametro: 'idfilial',     	  valor : vself.$store.state.filialpadrao.codfil},
								{parametro: 'idusuario',          valor : vself.$store.state.usuario.id},
								{parametro: 'codop',              valor : parseInt(this.opcrud) === 1 ? '001Z.010Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.010Z.002Z' : '001Z.010Z.003Z'},
							];
							let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmesascomandas.php');
							retorno.then(function (response) {
								loader.hide();
								if ($.isNumeric(response.data)){
									vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
									vself.mtdcancelaredicao();
									vself.mtdexecutapesquisa();
									$("#mdselecionarcomanda").modal("hide");
						
								}else{
									let tpret = response.data.substring(0,1);
									switch (tpret) {
										case 'I':
											vself.$toastr.w(response.data.substring(4), 'Atenção!');
											break;
										case 'E': default:
											vself.$toastr.e(response.data.substring(4), 'Erro!');
											break;
									}
								}
							}).catch(function (response) {
								loader.hide();
								vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
							});
						},
					},
					nao: {
						text: '<u>N</u>ão',
						keys: ['n', 'N'],
						action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
			},
			mtdconfirmamigranovacomanda(){
				let vself = this;
				if(parseInt(this.vidnovacomanda) === parseInt(this.vidcomandaedicao)){
					this.$toastr.w('as comandas/mesas não podem ser iguais', 'Atenção!');
					return
				}
				let ind = util.getArrayIndexForKey(this.lstmesascomandas, 'id', this.vidnovacomanda);

				if(parseInt(this.lstmesascomandas[ind].ocupado)=== 1){
					this.$toastr.w('a comanda/mesa informada esta ocupada!', 'Atenção!');
					return
				}
				if((parseInt(this.vidnovacomanda) > this.lstmesascomandas.length)||(parseInt(this.vidnovacomanda) <= 0 )){
					this.$toastr.w('o número informado é inválido!', 'Atenção!');
					return
				}

				
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma a migração da comanda?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
					sim: {
						text: '<u>S</u>im',
						keys: ['s', 'S'],
						btnClass: 'btn-blue',
						action: function () {
							$('.btn-blue').prop('disabled', true);

							let loader = vself.$loading.show();
		
							let parametros      = [
								{parametro: 'idclientesac',  	  valor : vself.$store.state.filialpadrao.idcliente},
								{parametro: 'op',           	  valor : 'migrarcomanda'}, 
								{parametro: 'idcomanda',          valor : vself.vidcomandaedicao},
								{parametro: 'idnovacomanda',      valor : vself.vidnovacomanda},
								{parametro: 'idfilialcomanda',    valor : vself.pidfilial},
								{parametro: 'idfilial',     	  valor : vself.$store.state.filialpadrao.codfil},
								{parametro: 'idusuario',          valor : vself.$store.state.usuario.id},
								{parametro: 'codop',              valor : parseInt(this.opcrud) === 1 ? '001Z.010Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.010Z.002Z' : '001Z.010Z.003Z'},
							];
							let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmesascomandas.php');
							retorno.then(function (response) {
								loader.hide();
								if ($.isNumeric(response.data)){
									vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
									vself.mtdcancelaredicao();
									vself.mtdexecutapesquisa();
									$("#mdselecionarcomanda").modal("hide");
						
								}else{
									let tpret = response.data.substring(0,1);
									switch (tpret) {
										case 'I':
											vself.$toastr.w(response.data.substring(4), 'Atenção!');
											break;
										case 'E': default:
											vself.$toastr.e(response.data.substring(4), 'Erro!');
											break;
									}
								}
							}).catch(function (response) {
								loader.hide();
								vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
							});
						},
					},
					nao: {
						text: '<u>N</u>ão',
						keys: ['n', 'N'],
						action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
				
			},
			mtdunircomanda(){
				if(!util.opcaousuario('020Z.040Z.030Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Seu perfil de usuário não permite realizar essa ação!', 'Informação!');
					return
				}
				this.opcomanda      = 2;
				this.vidnovacomanda = this.vidcomandaedicao;
				$("#mdselecionarcomanda").modal("show");
			},
			mtdmigrarcomanda(){
				if(!util.opcaousuario('020Z.040Z.020Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Seu perfil de usuário não permite realizar essa ação!', 'Informação!');
					return
				}
				this.opcomanda      = 1;
				this.vidnovacomanda = this.vidcomandaedicao;
				$("#mdselecionarcomanda").modal("show");
			},
			mtdliberarcomanda(){
				let vself = this;
				
				if(!util.opcaousuario('020Z.040Z.040Z', this.$store.state.perfilusuario)){
					vself.$toastr.i('Seu perfil de usuário não permite realizar essa ação!', 'Informação!');
					return
				}


				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma a liberação da comanda?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
					sim: {
						text: '<u>S</u>im',
						keys: ['s', 'S'],
						btnClass: 'btn-blue',
						action: function () {
							$('.btn-blue').prop('disabled', true);

							let loader = vself.$loading.show();
		
							let parametros      = [
								{parametro: 'idclientesac',  	  valor : vself.$store.state.filialpadrao.idcliente},
								{parametro: 'op',           	  valor : 'liberarcomanda'}, 
								{parametro: 'idcomanda',          valor : vself.vidcomandaedicao},
								{parametro: 'idfilialcomanda',    valor : vself.pidfilial},
								{parametro: 'idfilial',     	  valor : vself.$store.state.filialpadrao.codfil},
								{parametro: 'idusuario',          valor : vself.$store.state.usuario.id},
								{parametro: 'codop',              valor : parseInt(this.opcrud) === 1 ? '001Z.010Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.010Z.002Z' : '001Z.010Z.003Z'},
							];
							let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmesascomandas.php');
							retorno.then(function (response) {
								loader.hide();
								if ($.isNumeric(response.data)){
									vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
									vself.mtdcancelaredicao();
									vself.mtdexecutapesquisa();
						
								}else{
									let tpret = response.data.substring(0,1);
									switch (tpret) {
										case 'I':
											vself.$toastr.w(response.data.substring(4), 'Atenção!');
											break;
										case 'E': default:
											vself.$toastr.e(response.data.substring(4), 'Erro!');
											break;
									}
								}
							}).catch(function (response) {
								loader.hide();
								vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
							});
						},
					},
					nao: {
						text: '<u>N</u>ão',
						keys: ['n', 'N'],
						action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
			},
			mtdimprimircomanda(){
				let vself  = this;

				window.open(vself.$store.state.configpaths.pathcontrole+'rtimprimircomanda.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
							'&opcomanda=imprimircomanda'+
							'&idfilial='+vself.pidfilial+
							'&comanda='+vself.vidcomandaedicao+
							'&usuario='+vself.$store.state.usuario.id, '_blank');
			},
			mtdquantidade(op){
				
				if (parseInt(op) === 1){
					this.vqtditemedicao++;
				}else{
					if (parseFloat(this.vqtditemedicao) > 1){
						this.vqtditemedicao--;
					}
				}
			},
			mtdgravaritem(){
				if (parseFloat(this.vqtditemedicao) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemedicao').focus();
					return;
				}
				if (!util.opcaousuario('020Z.015Z.051Z', this.$store.state.perfilusuario)){
					if (parseFloat(this.vvlunitarioedicao) <= 0){
						this.$toastr.w('Valor do produto deve ser informado!', 'Atenção!');
						$('#edvlunitarioedicao').focus();
						return;
					}
				}
				let fatd = 0;
							
				if (parseInt(this.vtipodescacresedicao) === 0){
					fatd = this.vvalordescacresedicao;
				}else{
					fatd = parseFloat(this.vvalordescacresedicao) / (parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao)) * 100;
				}
			
				let descto_comparar = this.$store.state.usuario.descontoprodutos;

				if (parseFloat(fatd) > parseFloat(descto_comparar)){
					this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
					$('#cbtipodesctotal').focus();					
					return;
				}
								
		
				//desabilita botão gravar para evitar clique duplo
				$('#btnsalvaritem').prop('disabled', true);

					
                console.log("iniciardep");
               
				
                let lsttmp 							= this.lstitens;


                this.lstitens						= [];

				
          
				lsttmp[this.indiceitem].qtditem			= this.vqtditemedicao;
				lsttmp[this.indiceitem].valor		    = this.vvlunitarioedicao;
				lsttmp[this.indiceitem].tpdesconto	    = this.vtipodescacresedicao;
				lsttmp[this.indiceitem].desconto	    = this.vvalordescacresedicao;
				lsttmp[this.indiceitem].total			= this.vvltotaledicao;   

				this.lstitens 						    = lsttmp;       
				this.vtotalproduto                      = 0;

				for (let ind = 0; ind < this.lstitens.length; ind++) {
					this.vtotalproduto 				   = this.vtotalproduto + parseFloat(this.lstitens[ind].total);
					
				}


				if(this.vtptaxafil===0){
					this.vtxservico = this.vtaxafil;
				}else{
					this.vtxservico = this.vtotalproduto * this.vtaxafil / 100;
				}



				$('#mdedicaoitem').modal('hide');
				setTimeout(() => {
					$('#btnsalvaritem').prop('disabled', false);
				}, 500);				
            },
			mtdeditaritem(item, indice){
				if(!util.opcaousuario('020Z.040Z.050Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Seu perfil de usuário não permite realizar essa ação!', 'Informação!');
					return
				}
				this.mtdcancelaredicaoitem();
				this.indiceitem               = indice         
				this.vcoddigedicao            = item.idproduto
				this.vdescricaoprodutoedicao  = item.descricao
				this.vqtditemedicao			  = item.qtditem
				this.vtipodescacresedicao     = item.tpdesconto
				this.vvalordescacresedicao    = item.desconto
				this.vvlunitarioedicao        = item.valor
				this.vvltotaledicao           = item.total
				$("#mdedicaoitem").modal("show");
			},
			mtdcancelaredicaoitem(){
				this.indiceitem               = 0;         
				this.vcoddigedicao            = '';
				this.vdescricaoprodutoedicao  = '';
				this.vqtditemedicao			  = 0;
				this.vtipodescacresedicao     = 0;
				this.vvalordescacresedicao    = 0;
				this.vvlunitarioedicao        = 0;
				this.vvltotaledicao           = 0;
			},
			mtdexcluiritem(item, indice){
				this.lstitens.splice(indice, 1);


				for (let ind = 0; ind < this.lstitens.length; ind++) {
					this.vtotalproduto 				   = this.vtotalproduto + parseFloat(this.lstitens[ind].total);
					
				}

				if(this.vtptaxafil===0){
					this.vtxservico = this.vtaxafil;
				}else{
					this.vtxservico = this.vtotalproduto * this.vtaxafil / 100;
				}
			},
			mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
		
                let registrocrud = {
                    'id'              : this.vidcomandaedicao,
                    'qtdpessoas'      : this.vqtdpessoasedicao,
					'estadoedicao'    : this.vestadoedicao,
					'totmesa'         : this.vtotalproduto,
					'tottaxa'         : this.vtxservico,
					'idfilial'        : this.pidfilial,
					'itens'           : this.lstitens,
					'solicitouconta'  : 0, //adicionar uma variavel
					'dthoracomanda'   : util.DataAtual(true, true),
				
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gravarmesacomanda'},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.010Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.010Z.002Z' : '001Z.010Z.003Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmesascomandas.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.mtdcancelaredicao();
						vself.mtdexecutapesquisa();
            
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
			mtdgravar(){
				let vself = this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma operação na comanda?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
					sim: {
						text: '<u>S</u>im',
						keys: ['s', 'S'],
						btnClass: 'btn-blue',
						action: function () {
							$('.btn-blue').prop('disabled', true);
							vself.mtdregistro();
						},
					},
					nao: {
						text: '<u>N</u>ão',
						keys: ['n', 'N'],
						action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
			},
			mtdincluirproduto(index){
				this.vitem++;
				let itemtmp = {
					item        : this.vitem,
					idproduto   : this.lstitensbotoes[index].idproduto,
					descricao   : this.lstitensbotoes[index].descricao,
					valor       : this.lstitensbotoes[index].valor,
					desconto    : 0,
					tpdesconto  : 0,
					qtditem     : this.lstitensbotoes[index].qtd,
					total       : this.lstitensbotoes[index].total,
				}
				this.vtotalproduto = parseFloat(this.vtotalproduto) + parseFloat(this.lstitensbotoes[index].total);
				this.lstitens.push(itemtmp); 
				
				if(this.vtptaxafil===0){
					this.vtxservico = this.vtaxafil;
				}else{
					this.vtxservico = this.vtotalproduto * this.vtaxafil / 100;
				}
			},
			mtdalterarqtd(aumentar, qtd, indiceitem){              
				if (aumentar) {
					this.lstitensbotoes[indiceitem].qtd   += parseFloat(qtd); 
					this.lstitensbotoes[indiceitem].total  = util.arredondaValores(parseFloat(this.lstitensbotoes[indiceitem].qtd) * parseFloat(this.lstitensbotoes[indiceitem].valor), 3, 'round'); 
					
				}else{
					if (parseFloat(this.lstitensbotoes[indiceitem].qtd) > 1){
						this.lstitensbotoes[indiceitem].qtd       -= parseFloat(qtd);
						this.lstitensbotoes[indiceitem].total      = util.arredondaValores(parseFloat(this.lstitensbotoes[indiceitem].qtd) * parseFloat(this.lstitensbotoes[indiceitem].valor), 3, 'round');                   
					}else{
						return;
					}
				}    
			
            },
			mtdselecionabotao(i){
				this.lstitensbotoes = [];
				for (let index = 0; index < this.lstbotoes.length; index++) {
					if(index !== i){
						this.lstbotoes[index].ativo = 0; 
					}else{
						this.lstbotoes[index].ativo = 1; 
						this.lstitensbotoes = this.lstbotoes[index].itensbotoes
					}
				}
			},
			mtdlanciten(){
				setTimeout(() => {
					$('#slickbtns').slick({
						infinite: true,
						slidesToShow: 3,
						slidesToScroll: 3
				    });
				}, 500);

				this.mtdselecionabotao(0);

				$('#mdlanciten').modal('show');
			},
			mtdgerenciarmesa(mesa){
				
				if(util.opcaousuario('020Z.040Z.010Z', this.$store.state.perfilusuario)){
					this.lstitens                = mesa.itens; 
					this.vidcomandaedicao        = mesa.id;
					this.vqtdpessoasedicao       = mesa.qtdpessoas;
					this.vestadoedicao           = mesa.ocupado;
					this.vtotalproduto           = mesa.totmesa; 
					this.vtxservico              = mesa.tottaxa; 
					if(this.lstitens.length > 0){
						this.vitem                   = this.lstitens[this.lstitens.length - 1].item;
					}else{
						this.vitem                   = 0;
					}
					$('#pnlista').hide();
					$('#pncadastro').fadeIn(700);
				}else{
					this.$toastr.i('Seu perfil de usuário não permite realizar essa ação!', 'Atenção!');
				}
			

				// $('#mdmesa').modal('show');
           
			},
            mtdformatavalordecimal(valor, digitos) {
                return util.formatavalordecimais(valor, digitos);
            },
			mtdcancelaredicao(){
				this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){

                    util.toTop();
                }, 200);
            },
            mtdexecutapesquisa(){
                let vself  = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}	
                let loader = vself.$loading.show();
                let parametros = [
                        {parametro: 'op',           valor  : 'gerenciarmesascomandas'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                        {parametro: 'idfilial',     valor  : vself.pidfilial}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmesascomandas.php');
                retorno.then(function (response) {
                     loader.hide();
                     vself.lstmesascomandas = response.data.mesascomandas;
					 vself.lstbotoes        = response.data.botoesrapido[0].botoes;     
                   
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }, 
			mtdselect2_def(){
				let vself = this;
                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';

                $("#edcep").blur(function(){
                    vself.mtdpesquisacep();
                });
				
				$("#mdselecionarcomanda").on('hide.bs.modal', function(){
					vself.opcomanda = 0;
				});
				$("#mdlanciten").on('hide.bs.modal', function(){
					$('#slickbtns').slick('unslick');
				});
				$("#mdedicaoitem").on('hide.bs.modal', function(){
					vself.mtdcancelaredicaoitem();
				});

				

				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();

					if(vself.pidfilial !== null){
						let loader = vself.$loading.show();
						let parametros = [
								{parametro: 'op',           valor  : 'pegataxafilial'},
								{parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
								{parametro: 'idusuario',    valor  : vself.$store.state.usuario.id},
								{parametro: 'idfilial',     valor  : vself.pidfilial}
						];
						let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmesascomandas.php');
						retorno.then(function (response) {
								///////////
								vself.vtaxafil   = parseFloat(response.data.taxa);
								vself.vtptaxafil = parseInt(response.data.tptaxa);
								loader.hide();

						}).catch(function (response) {
								/////////
								loader.hide();
						});
					}

					vself.lstmesascomandas = [];
				});

				if(vself.utodasfiliais!==0){
					if($("#pnlista").is(":visible")){
				
						vself.pidfilial  = null;

						var deffil  = new Option(vself.$store.state.filialpadrao.fantasia, vself.$store.state.filialpadrao.codfil, true, true);
						$('#cbfilialpesq').append(deffil).trigger('change');
				
					}
				}
            }
		},
		mounted: function () {

			if (util.verificasessao(this)) {
					let vself = this;
					let loader = vself.$loading.show();
					let parametros = [
							{parametro: 'op',           valor: 'dadosusuario'},
							{parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
							{parametro: 'idusuario',    valor  : vself.$store.state.usuario.id}
					];
					let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
					retorno.then(function (response) {
							loader.hide();
							vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
							if (util.opcaousuario('020Z.040Z', vself.$store.state.perfilusuario)) {
									$('#pnlista').fadeIn(700);
									//vself.mtdexecutapesquisa();
									vself.mtdselect2_def();
							} else {
									vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
									setTimeout(function(){
											util.gotoprincipal();
									},1000);
							}
					}).catch(function (response) {
							loader.hide();
							console.log(response.message);
					});
			}
		},
		computed:{
			calculatotalitem() {
				let valdescacres = 0;
				switch (parseInt(this.vtipodescacresedicao)) {
					case 0://Percentual
						valdescacres = this.vqtditemedicao * this.vvlunitarioedicao * this.vvalordescacresedicao / 100;
						break;
					case 1://Valor
						valdescacres = this.vvalordescacresedicao;
						break;
				}
				this.vvltotaledicao = (this.vqtditemedicao * this.vvlunitarioedicao) - valdescacres;
				// switch (parseInt(this.vdescacresedicao)){
				// 	case 0://Desconto
				// 		this.vvltotaledicao = (this.vqtditemedicao * this.vvlunitarioedicao) - valdescacres;
				// 		break;
				// 	case 1://Acrescimo
				// 		this.vvltotaledicao = (this.vqtditemedicao * this.vvlunitarioedicao) + valdescacres;
				// 		break;
				// }
            },
		},
		// watch:{
		// 	    pidfilial(val){
				
		// 		}
		// }
	}
</script>
<style>
div.scrollmenu {
  background-color: #333;
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  color: white;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

div.scrollmenu a:hover {
  background-color: #777;
}
.cardbtn{

	border-radius: 10px !important;
}
.cardbtn-ativo{
	
    border-radius: 10px !important;
	background-color: #add8e6 !important;
}
@media (max-width: 365px) {
	.descmini{
		font-size: x-small;
	}
	.responsive{
		font-size: x-small;
    }
}

</style>